<script setup>
import { computed } from 'vue';

const props = defineProps({
  agentIds: {
    type: Array,
    default: () => [],
  },
  agents: {
    type: Array,
    default: () => [],
  },
});

const selectedAgents = computed(() => {
  const selectedIds = new Set(props.agentIds.map(Number));
  return props.agents.filter(agent => selectedIds.has(Number(agent.id)));
});

const onlineCount = computed(
  () =>
    selectedAgents.value.filter(agent => agent.availability_status === 'online')
      .length
);
</script>

<template>
  <span
    v-if="!selectedAgents.length"
    class="inline-flex rounded-md bg-n-alpha-2 px-2 py-1 text-xs text-n-slate-10"
  >
    {{ $t('ASSIGNMENT_ROUTING.COMMON.NO_CANDIDATES') }}
  </span>
  <details v-else class="group min-w-36">
    <summary
      class="cursor-pointer list-none text-sm font-medium text-n-slate-12 hover:text-n-brand"
    >
      {{
        $t('ASSIGNMENT_ROUTING.COMMON.CANDIDATE_COUNT', {
          count: selectedAgents.length,
        })
      }}
      <span class="font-normal text-n-slate-10">
        ·
        {{
          $t('ASSIGNMENT_ROUTING.COMMON.ONLINE_COUNT', {
            count: onlineCount,
          })
        }}
      </span>
    </summary>
    <div class="mt-2 flex max-w-md flex-wrap gap-1.5">
      <span
        v-for="agent in selectedAgents"
        :key="agent.id"
        class="inline-flex items-center gap-1.5 rounded-md border border-n-weak bg-n-alpha-1 px-2 py-1 text-xs text-n-slate-11"
      >
        <span
          class="size-1.5 rounded-full"
          :class="
            agent.availability_status === 'online'
              ? 'bg-n-teal-9'
              : 'bg-n-slate-7'
          "
        />
        {{ agent.name }}
      </span>
    </div>
  </details>
</template>
